import { currentLeague, leagueUrl, navigationType, shouldRedirectToAhl } from './core/league/league';
import { getSetting, settings } from './core/settings/settings';
import mountApp from './ui/shell/mount';

// A fresh visit to the front page opens the AHL page if the AHL was chosen last.
if (shouldRedirectToAhl(window.location.pathname, getSetting(settings.league), navigationType())) {
    window.location.replace(leagueUrl('AHL', window.location.hash));
} else {
    if (currentLeague() === 'AHL') {
        document.title = 'NHLCountries · AHL';
    }
    mountApp(document.getElementById('root') as HTMLElement);
}
